import { Icon } from '@arco-design/web-vue';

const selfIcon = Icon.addFromIconFontCn({
  src: '/public/icon.js',
});

export default selfIcon;
